customElements.define('cart-drawer-recommend', class CartDrawerRecommend extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    if (!document.querySelector('#CartDrawer .drawer__inner-empty')) {
      this.modifyCartRecommendProdList();
      this.cartDrawerItems = this.closest('cart-drawer-items');

      this.debouncedOnClick = debounce((event) => {
        this.onClickAddButton(event);
      }, 300);
      this.querySelectorAll('.cdr-add-btn').forEach((el) => {
        el.addEventListener('click', this.debouncedOnClick);
      });
    }
  }

  modifyCartRecommendProdList() {
    var recommend_data_origin = this.querySelector('#settings_recommend_data_origin')?.innerText?.trim();
    if (recommend_data_origin != 'self_define')
      return;

    const $prod_list = $(this.querySelector('.cart-recommend-prod-main .cdr-prod-list'));
    $prod_list.empty();
    $prod_list.append($("#card-recommend-prod-list").html());
    if ($("#card-recommend-prod-list")?.html()?.trim()) {
      $(this.querySelector('.cart-recommend-prod-main')).removeClass('hide');
    }
  }

  onClickAddButton(evt) {
    const id = evt.target.closest('.cdr-add-card').querySelector('[data-id="id"').value;
    const data = JSON.stringify({
      id,
      quantity: 1,
      sections: this.cartDrawerItems.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });
    this.addRecommendProd(data);
  }

  addRecommendProd(data) {
    this.cartDrawerItems.handleFetchRequest(fetch(`${routes.cart_add_url}`, { ...fetchConfig(), ...{ body: data } }));
  }
});